export const createIndexSizeError = () => new DOMException('', 'IndexSizeError');
//# sourceMappingURL=index-size-error.js.map